"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractProvenance = void 0;
const path = require("path");
const debugLib = require("debug");
const requirements_file_parser_1 = require("./update-dependencies/requirements-file-parser");
const contains_require_directive_1 = require("./contains-require-directive");
const debug = debugLib('snyk-fix:python:extract-version-provenance');
async function extractProvenance(workspace, rootDir, dir, fileName, provenance = {}) {
    const requirementsFileName = path.join(dir, fileName);
    const requirementsTxt = await workspace.readFile(requirementsFileName);
    // keep all provenance paths with `/` as a separator
    const relativeTargetFileName = path
        .normalize(path.relative(rootDir, requirementsFileName))
        .replace(path.sep, '/');
    provenance = {
        ...provenance,
        [relativeTargetFileName]: (0, requirements_file_parser_1.parseRequirementsFile)(requirementsTxt),
    };
    const { containsRequire, matches } = await (0, contains_require_directive_1.containsRequireDirective)(requirementsTxt);
    if (containsRequire) {
        for (const match of matches) {
            const requiredFilePath = match[2];
            if (provenance[requiredFilePath]) {
                debug('Detected recursive require directive, skipping');
                continue;
            }
            const { dir: requireDir, base } = path.parse(path.join(dir, requiredFilePath));
            provenance = {
                ...provenance,
                ...(await extractProvenance(workspace, rootDir, requireDir, base, provenance)),
            };
        }
    }
    return provenance;
}
exports.extractProvenance = extractProvenance;
//# sourceMappingURL=extract-version-provenance.js.map